<style type="less" scoped>
    @import url('./css.less');
    
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
        <div class="map-rank" v-for="(it,index) in top10" :key="it.value"
            :style="{left:it.pixel.x+'px',top:it.pixel.y+'px'}">
            <i class="num">{{index+1}}</i>
            <div class="detail">
                <p class="city">{{it.name}}</p>
                <p class="value">{{it.value}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../../map/common/businessEchartBmap/index';
    import ChinaProvincePolygonOveraly from './../../map/common/inMapOverlay/ChinaProvince-Polygon/index';
    import mapPropsMinxin from './default-props-value';
    import allData from './labourPerson';
    import FlyOverlay from './flyOverlay';
    import {
        BluenessNoLabel
    } from './../../map/common/map-config';
    const data = [{
        "geometry": {
            "type": "Point",
            "coordinates": [116.54611555876909, 40.26940227400542]
        },
        name: "圆点一",
        "count": 60
    }];
    export default {
        name: '',
        props: {
            cityName: {
                type: String,
                default: "北京市"
            },
            cityData: []
        },
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            return {
                top10: [],
                citys: ['广东省', '黑龙江省', '北京市']
            }
        },
        watch: {
            cityName() {
                this._setData(this.cityName);
                console.log('cityName', this.cityName)
            },
            cityData() {
                console.log('data', this.data)
            }
        },
        computed: {

        },
        methods: {
            _setData(cityName) {
                const data = allData.filter((item) => {
                    return item.to.name == cityName;
                });
                const mapComponent = this.$refs.map.getMapComponent();

                mapComponent.setStyle(BluenessNoLabel);
                //关闭zoom
                mapComponent.setZoomConfig({
                    show: false,
                });
                // //关闭拖拽


                const flyOverlay = new FlyOverlay({
                    type: 2
                });
                flyOverlay.setValue(data);
                mapComponent.setEchartLayers([flyOverlay]);
                const polygonOverlay = new ChinaProvincePolygonOveraly({
                    style: {
                        mouseOver: {
                            backgroundColor: "rgba(0,133,235,0.6)",
                        },
                        selected: {
                            backgroundColor: "rgba(25,158,255,1)",
                            borderColor: "rgba(25,158,255,1)",
                        },
                    }
                });
                mapComponent.addInMapOverlay(polygonOverlay);
                polygonOverlay.setValue([]);
                polygonOverlay.setSelectedByName(cityName);

                const bMap = mapComponent.getMap();
                bMap.disableDragging();
                bMap.addEventListener('moveend', () => {
                    this.addLables(flyOverlay, bMap);
                });
                bMap.addEventListener('zoomend', () => {
                    this.addLables(flyOverlay, bMap);
                });
                this.addLables(flyOverlay, bMap);
            },
            addLables(flyOverlay, bMap) {
                this.top10 = flyOverlay.getLables(bMap);
            },
            mapLoad() {
                this._setData(this.cityName);

                setTimeout(() => {
                    this._setData('广东省');
                }, 6000);
            },
             resize() {
                this.$refs.map.resize();
            }
        },
        mounted() {

        }
    }
</script>